import ControllerService from './../services/ControllerService'

export default {
    namespaced: true,
    state: () => ({
        methodsList: []
    }),
    mutations: {
        setMethodsList: (state, methodsList) => {
            state.methodsList = methodsList
        }
    },
    actions: {
        getMethodsList: ({commit}, payload) => {
            return new Promise((resolve, reject) => {
                ControllerService.methodsList(payload).then(res => {
                        commit('setMethodsList', res.data)
                        resolve(res)
                }).catch((err) => {
                    reject(err)
                })
                })
            }
    }
}